import { Section } from '@/pages/CompanyReport/components/Overview/components/Section';
import { SubSectionHeader } from '@/pages/CompanyReport/components/Overview/components/SubSectionHeader';
import { LegacyAnchor } from '@/constants/anchors';
import PageAnchor from '@components/PageAnchor';
import { MarketPerformance } from './components/MarketPerformance';
import { RecentUpdates } from '@/pages/CompanyReport/components/Overview/components/RecentUpdates';
import { useDwellTracking } from '@/pages/CompanyReport/components/DwellTrackingProvider';
import { useReportSection } from '@/pages/CompanyReport/components/ReportSectionProvider';
import { useOverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';
import loadable from '@loadable/component';

const SharePrice = loadable(() => import('./components/SharePrice'), {
  resolveComponent: (components) => components.SharePrice,
});

interface Props {
  lookup: string;
  id: string | null;
  uniqueSymbol: string;
}
export function PricePerformance({ id, lookup, uniqueSymbol }: Props) {
  const { observe } = useDwellTracking();
  const { section } = useReportSection();
  const t = useOverviewTranslation();

  return (
    <Section
      data-cy-id="price-performance"
      data-section={section}
      ref={observe}
    >
      <SubSectionHeader>{t('pricePerformance.title')}</SubSectionHeader>
      <PageAnchor
        type="sub-section-title"
        id={LegacyAnchor.HEADER_PRICE_EVENTS}
      />
      {id ? (
        <SharePrice id={id} lookup={lookup} uniqueSymbol={uniqueSymbol} />
      ) : null}
      <RecentUpdates lookupValue={lookup} />
      <MarketPerformance />
    </Section>
  );
}
